import { render } from "./JlDatatable.vue?vue&type=template&id=00bc4c06"
import script from "./JlDatatable.vue?vue&type=script&lang=js"
export * from "./JlDatatable.vue?vue&type=script&lang=js"

import exportComponent from "D:\\DockerProjects\\armt_pos_v2_docker\\client\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__